import React from 'react';

import { useSelector } from 'react-redux';

const ShowWhenHotelsTabSelected = ({ children }) => {
    const isHotelsTabSelected = useSelector(
        (state) => state?.activeProduct?.activeProduct === 'hotels'
    );

    return isHotelsTabSelected ? <>{children()}</> : null;
};

export default ShowWhenHotelsTabSelected;
